import {Component, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {UserEnEchange, UserEnEchangeService} from '../../entities/user-en-echange';

@Injectable()
export class UserEchangeModalService {
    private isOpen = false;
    constructor (
        private modalService: NgbModal,
        private router: Router,
        private userEchangeService: UserEnEchangeService
    ) {}

    open(component: Component, id?: number, typeEtudiant?: number): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.userEchangeService.find(id).subscribe(user => this.userModalRef(component, user));
        } else {
            let user = new UserEnEchange();
            user.typeEtudiant = typeEtudiant;
            return this.userModalRef(component, user);
        }
    }

    userModalRef(component: Component, user: UserEnEchange): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.user = user;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-echange/user-echange-modal.service.ts